<template>
  <div class="Classe Page__container">
    <div v-html="text" />
  </div>
</template>

<script>
export default {
  name: 'Classe',
  computed: {
    text() {
      return this.$store.getters['app/pages']['options/en-classe'][this.lang].text
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Classe
  position relative
</style>




// WEBPACK FOOTER //
// src/components/navigation/pages/Classe.vue